require('../position/position.css');
require('./tooltip.css');
module.exports = require('./index-nocss.js');



//////////////////
// WEBPACK FOOTER
// ../~/angular-ui-bootstrap/src/tooltip/index.js
// module id = 169
// module chunks = 0